'use client';

import React from 'react';
import i18n from '@shared/i18n';
import { type BuyerLayoutProps } from 'shop-ui/types';

interface ProductCartButtonsProps extends BuyerLayoutProps<Product> {}

export const ProductCartButtons: React.FC<ProductCartButtonsProps> = (props) => {
    const { __ssr = {} } = props;

    const { product } = __ssr;

    const outOfStock = product?.total_stock && product.total_stock <= 0;

    return (
        <div>
            <button className="skeleton skeleton--ssr skeleton--lg">
                <span className="ssr-hidden">
                    {outOfStock ? i18n.gettext('已售完') : i18n.gettext('加入購物車')}
                </span>
            </button>
            {!outOfStock && (
                <button className="skeleton skeleton--ssr skeleton--lg">
                    <span className="ssr-hidden">{i18n.gettext('直接購買')}</span>
                </button>
            )}
        </div>
    );
};
